import script from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=788cdab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788cdab6"]])

export default __exports__